import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Category } from '../models/category-model';
import { CategoryService } from '../services/category.service';


@Component({
  selector: 'app-category-form',
  templateUrl: './category-form.component.html'
})
export class CategoryFormComponent implements OnInit {
  categoryForm!: FormGroup;
  isEdit = false;
  categoryId?: number;
  categories: Category[] = [];

  constructor(
    private fb: FormBuilder,
    private categoryService: CategoryService,
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.categoryForm = this.fb.group({
      name: ['', Validators.required],
      parentId: [null]
    });

    this.loadCategories();

    this.categoryId = +this.route.snapshot.paramMap.get('id')!;
    if (this.categoryId) {
      this.isEdit = true;
      this.categoryService.getCategory(this.categoryId).subscribe(c => {
        this.categoryForm.patchValue(c);
      });
    }
  }

  loadCategories() {
    this.categoryService.getCategories().subscribe({
      next: (res: any) => {
        this.categories = res.items;
      },
      error: (err) => console.error('Failed to remove item:', err)
    });
  }

  onSubmit() {
    if (this.categoryForm.invalid) return;

    if (this.isEdit && this.categoryId) {
      this.categoryService.updateCategory(this.categoryId, this.categoryForm.value)
        .subscribe(() => this.router.navigate(['/admin/categories']));
    } else {
      this.categoryService.createCategory(this.categoryForm.value)
        .subscribe(() => this.router.navigate(['/admin/categories']));
    }
  }
}
